import { Button, Space } from "antd";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";

import DiscountCodePickerModal from "../DiscountCodePickerModal";
import DiscountCodeFormModal from "../DiscountCodeFormModal";
import DiscountCodeList from "../DiscountCodeList";

import { DiscountCodeListFiledProps } from "./types";
import { useDiscountCodeListFiled } from "./hooks";

const DiscountCodeListFiled: React.FC<DiscountCodeListFiledProps> = (props) => {
  const { list, picker, form, openPickerModal, openFormModal } =
    useDiscountCodeListFiled(props);

  return (
    <>
      <Header>
        <Space>
          <Button type="primary" htmlType="button" onClick={openFormModal}>
            <FormattedMessage defaultMessage="Add New Discount Code" />
          </Button>{" "}
          <Button type="primary" htmlType="button" onClick={openPickerModal}>
            <FormattedMessage defaultMessage="Add Existing Discount Code" />
          </Button>
        </Space>
      </Header>
      <DiscountCodeList {...list} />
      <DiscountCodePickerModal {...picker} />
      <DiscountCodeFormModal {...form} />
    </>
  );
};

export default DiscountCodeListFiled;
